const name = 'circle-p';

const contents = '<path d="M32.201 26.829c2.983 0 5.33.828 7.043 2.485s2.569 3.84 2.569 6.546c0 2.762-.856 4.944-2.569 6.546-1.712 1.602-4.06 2.403-7.043 2.403h-6.38V55h-5.634V26.829h12.014zm-.497 4.64h-5.883v8.7h5.883c1.326 0 2.403-.332 3.232-.995.828-.663 1.243-1.767 1.243-3.314 0-1.491-.415-2.596-1.243-3.314-.829-.718-1.906-1.077-3.232-1.077z" fill="#FFF"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'P',
};

export default icon;
